import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';

import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgToastService } from 'ng-angular-popup';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { ApplicantPqqSectionsComponent } from '../applicant-pqq-sections.component';
import { FileManagerComponent } from '../../../../../../shared/file-manager/file-manager.component';

@Component({
  standalone: true,
  imports: [
    MatExpansionModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatRadioModule,
    FileManagerComponent,
  ],
  selector: 'app-qms',
  templateUrl: './qms.component.html',
  styleUrls: ['./qms.component.css'],
})
export class QmsComponent implements OnInit, OnChanges {
  @Input() applicantData: any;
  @Input() isEdit: boolean;
  formGroup: FormGroup;
  qualityCertificationsDetailFiles: any[] = [];
  deletedOldQualityCertificationsDetailIds: any[] = [];
  oldQualityCertificationsDetail: any[] = [];

  deletedoldComplianceProcessIds: any[] = [];
  oldComplianceProcess: any[] = [];

  oldDefectsManagement: any[] = [];
  deletedoldDefectsManagementIds: any[] = [];
  @Input() isFetchApplicantData: boolean;

  constructor(
    private fb: FormBuilder,
    private toast: NgToastService,
    private projectsService: ProjectsService,
    private router: Router,
    private ApplicantPqqSectionsComponent: ApplicantPqqSectionsComponent
  ) {}
  ngOnInit(): void {
    this.formGroup = this.fb.group({
      // Quality Management System (QMS)
      using_qms: ['0'],
      quality_certifications_detail: [''],
      compliance_process: [''],
      defects_management: [''],
      warranty_period: [''],

      qualityCertificationsDetailControl: new FormArray([]),
      complianceProcessControl: new FormArray([]),
      defectsManagementControl: new FormArray([]),
    });

    // If it's an edit scenario, patch the form with the applicant data
    if (this.isEdit) {
      this.patchFormValues();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['isFetchApplicantData'] &&
      !changes['isFetchApplicantData'].firstChange
    ) {
      this.patchFormValues();
    }
  }
  patchFormValues() {
    this.formGroup.patchValue({
      using_qms: String(this.applicantData?.using_qms) || '0',
      quality_certifications_detail:
        this.applicantData?.quality_certifications_detail || '',
      compliance_process: this.applicantData?.compliance_process || '',
      defects_management: this.applicantData?.defects_management || '',
      warranty_period: this.applicantData?.warranty_period || '',
    });
    this.addOldAttachmentMapping(this.applicantData);
  }

  handleBack() {
    this.ApplicantPqqSectionsComponent.previousStep();
  }

  prepareDataToSubmit() {
    const dataToSubmit = new FormData();

    // Dynamically append all form controls to FormData
    Object.keys(this.formGroup.controls).forEach((key) => {
      const value = this.formGroup.get(key)?.value;
      if (value !== null && value !== undefined && value !== '') {
        dataToSubmit.append(key, value);
      }
    });
    // Files handling Start
    this.addUploadedFiles(dataToSubmit);
    this.addDeletedOldFilesIds(dataToSubmit);
    // Files handling End
    return dataToSubmit;
  }

  // NOTE: on edit, we add old files to the form array
  addOldAttachmentMapping(response) {
    if (response.quality_certifications_attach) {
      this.oldQualityCertificationsDetail =
        response.quality_certifications_attach || [];
    }
    if (response.quality_standard_attach) {
      this.oldComplianceProcess = response.quality_standard_attach || [];
    }
    if (response.defects_warranty_attach) {
      this.oldComplianceProcess = response.defects_warranty_attach || [];
    }
  }
  addUploadedFiles(submissionFormData) {
    // Adding files to FormData
    this.formGroup.value.qualityCertificationsDetailControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append(
            'quality_certification_attach[]',
            uploadedFile
          );
        }
      }
    );
    this.formGroup.value.complianceProcessControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append('quality_standard_attach[]', uploadedFile);
        }
      }
    );
    this.formGroup.value.defectsManagementControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append(
            'defects_&_warranty_attach[]',
            uploadedFile
          );
        }
      }
    );
  }

  handleNewFiles(filesData: {
    files: File[];
    controlName: string;
    isEmpty: boolean;
  }) {
    switch (filesData.controlName) {
      case 'qualityCertificationsDetailControl': {
        const fileArray = this.formGroup.get(
          'qualityCertificationsDetailControl'
        ) as FormArray;
        fileArray.clear();

        // If no files are present, we break
        if (filesData.isEmpty) {
          break;
        }

        // Add new files to the form array
        filesData.files.forEach((file) =>
          fileArray.push(new FormControl(file))
        );
        break;
      }
      case 'complianceProcessControl': {
        const fileArray = this.formGroup.get(
          'complianceProcessControl'
        ) as FormArray;
        fileArray.clear();

        // If no files are present, we break
        if (filesData.isEmpty) {
          break;
        }

        // Add new files to the form array
        filesData.files.forEach((file) =>
          fileArray.push(new FormControl(file))
        );
        break;
      }
      case 'defectsManagementControl': {
        const fileArray = this.formGroup.get(
          'defectsManagementControl'
        ) as FormArray;
        fileArray.clear();

        // If no files are present, we break
        if (filesData.isEmpty) {
          break;
        }

        // Add new files to the form array
        filesData.files.forEach((file) =>
          fileArray.push(new FormControl(file))
        );
        break;
      }
      default:
        break;
    }
  }

  handleDeletedOldFiles(OldFileData: any) {
    switch (OldFileData.controlName) {
      case 'qualityCertificationsDetailControl': {
        this.deletedOldQualityCertificationsDetailIds.push(
          OldFileData?.file?.id
        );
        this.oldQualityCertificationsDetail =
          this.oldQualityCertificationsDetail.filter(
            (file) => file.id !== OldFileData?.file?.id
          );
        break;
      }
      case 'complianceProcessControl': {
        this.deletedoldComplianceProcessIds.push(OldFileData?.file?.id);
        this.oldComplianceProcess = this.oldComplianceProcess.filter(
          (file) => file.id !== OldFileData?.file?.id
        );
        break;
      }
      case 'defectsManagementControl': {
        this.deletedoldDefectsManagementIds.push(OldFileData?.file?.id);
        this.oldDefectsManagement = this.oldDefectsManagement.filter(
          (file) => file.id !== OldFileData?.file?.id
        );
        break;
      }
      default:
        break;
    }
  }

  addDeletedOldFilesIds(submissionFormData) {
    if (this.deletedOldQualityCertificationsDetailIds?.length > 0) {
      submissionFormData.append(
        'deleted_OldQuality_Certifications_Detail_Ids',
        JSON.stringify(this.deletedOldQualityCertificationsDetailIds)
      );
    }
    if (this.deletedoldComplianceProcessIds?.length > 0) {
      submissionFormData.append(
        'deleted_old_Compliance_Process_attach_Ids',
        JSON.stringify(this.deletedoldComplianceProcessIds)
      );
    }
    if (this.deletedoldDefectsManagementIds?.length > 0) {
      submissionFormData.append(
        'delete_defects_management_attach_ids',
        JSON.stringify(this.deletedoldDefectsManagementIds)
      );
    }
    // if (this.deletedOldCorporateResponsibilityFilesIds?.length > 0) {
    //   submissionFormData.append(
    //     'delete_corporate_social_responsibility_attach_ids',
    //     JSON.stringify(this.deletedOldCorporateResponsibilityFilesIds)
    //   );
    // }
  }
  onSubmit(): void {
    if (this.formGroup.valid) {
      const dataToSubmit = this.prepareDataToSubmit();
      this.projectsService.projectPQQResponseStep4(dataToSubmit).subscribe({
        next: () => {
          this.toast.success('Pre Qualification submitted', 'SUCCESS');
          this.ApplicantPqqSectionsComponent.nextStep();
        },
        error: (error: any) => {
          console.error('Failed to submit:', error);
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    } else {
      this.toast.warning('Please fill the required fields', 'WARNING');
      this.formGroup.markAllAsTouched(); // Highlights all invalid fields
    }
  }
}
